import { checkDeployEnv } from 'utils/checkDeployEnv';
import { useProductOverlaidList } from 'common/queries/product-module';
import { useCheckIsProductOverlay } from 'hooks';
import { useParams } from 'react-router-dom';

export const useCheckOverlaidList = () => {
  const { id } = useParams();
  const isProductOverlay = useCheckIsProductOverlay();

  const isProductionEnv = checkDeployEnv('production');
  const isDemoEnv = checkDeployEnv('demo');
  const isAvailableEnv = !isProductionEnv && !isDemoEnv;

  const { data: productOverlaidListData } = useProductOverlaidList(
    {
      productId: Number(id),
    },
    { enabled: !isProductOverlay && isAvailableEnv }
  );

  return {
    hasOverlaidList: productOverlaidListData?.gridData?.length > 0,
  };
};
